<template>
  <b-row class="border-bottom">
    <b-col cols="auto">
      <p class="text-primary mb-0">{{label}}</p>
    </b-col>
    <b-col class="text-right">
      <p class="text-secondary mb-0">{{content}}</p>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: "timesheetRow",
    props: {
      label: {
        type: String,
        required: true
      },
      content: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
